import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { TextField, TTextField } from '../lib/TextField';

interface ControlledTextFieldProps<T extends FieldValues>
  extends Omit<TTextField, 'name' | 'inputRef'> {
  name: Path<T>;
  control: Control<T>;
}

export const ControlledTextField = <T extends FieldValues>({
  name,
  control,
  ...props
}: ControlledTextFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { ref, ...restField } = field;

        return (
          <TextField
            {...restField}
            {...props}
            ref={ref}
            error={!!error}
            helperText={error?.message}
          />
        );
      }}
    />
  );
};
